/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import { HTMLAttributes } from 'react';
import styled from 'styled-components';
import ReCAPTCHA, { ReCAPTCHAProps } from 'react-google-recaptcha';
import { useGoogleRecaptchaContext } from '../providers';

export type GoogleRecaptchaProps = HTMLAttributes<HTMLDivElement>;

const GoogleRecaptchaV2 = (props: GoogleRecaptchaProps) => {
  const { version, setV2Ref, setV2Token } = useGoogleRecaptchaContext();

  const ReCAPTCHAComp = ReCAPTCHA as unknown as React.ComponentType<
    ReCAPTCHAProps & { ref?: React.Ref<ReCAPTCHA> }
  >;

  return version === 'V2' ? (
    <Wrapper {...props}>
      <ReCAPTCHAComp ref={setV2Ref} sitekey={key} onChange={setV2Token} />
    </Wrapper>
  ) : null;
};

const key = import.meta.env.VITE_GOOGLE_RECAPTCHA_V2 ?? '';

const Wrapper = styled.div`
  width: calc(100% + 2px);
  margin-top: 12px;
  margin-bottom: 8px;
  margin-right: -2px;
`;

export { GoogleRecaptchaV2 };
